import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Button, Col, Modal, Row} from "react-bootstrap";

import {resetEntity, showMessage} from '../actions';
import {loadGeneralEnum} from "../actions/enums";
import {deleteInvoice, loadInvoice, saveInvoice} from '../actions/invoices';
import {defaultState} from '../reducers/entity';
import InvoiceForm from '../components/invoice/InvoiceForm';
import {Acl, breadcrumbs, Grid} from "./../utils";

class InvoiceEditPage extends Component {

	constructor(props) {
		super(props);

		this.handleFetchEnums = this.handleFetchEnums.bind(this);
		this.handleSaveInvoice = this.handleSaveInvoice.bind(this);
		this.handleDeleteInvoice = this.handleDeleteInvoice.bind(this);
		this.handleOpenDeleteClick = this.handleOpenDeleteClick.bind(this);
		this.handleDismissDeleteClick = this.handleDismissDeleteClick.bind(this);

		this.state = {
			isDeleteModalOpen: false,
			deleteInvoice: null
		}
	}

	componentDidMount() {
		const invoiceId = (this.props.match.params.invoiceId || 'new')
		this.props.loadInvoice(invoiceId, 'new' !== invoiceId)
	}

	componentDidUpdate(prevProps) {
		const invoiceId = (this.props.match.params.invoiceId || 'new')
		if ((prevProps.match.params.invoiceId || 'new') !== invoiceId) {
			this.props.loadInvoice(invoiceId, 'new' !== invoiceId)
		}
	}

	componentWillUnmount() {
		this.props.resetEntity()
	}

	handleFetchEnums(enums) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], {})
			}
		}
	}

	handleSaveInvoice(invoice) {
		return this.props.saveInvoice(invoice).then((json) => {
			if (json && json.response && json.response.result === 'OK') {
				const invoiceId = json.response.data;
				// this.props.loadInvoice(invoiceId, true);
				return new Promise((resolve, reject) => resolve(this.props.history.push('/invoices/' + invoiceId)))
			} else {
				return new Promise((resolve, reject) => resolve())
			}
		})
	}

	handleOpenDeleteClick(invoice) {
		this.setState({isDeleteModalOpen: true, deleteInvoice: invoice})
	}

	handleDismissDeleteClick(e) {
		if (e) {
			e.preventDefault()
		}
		this.setState({isDeleteModalOpen: false, deleteInvoice: null})
	}

	handleDeleteInvoice(invoice) {
		return this.props.deleteInvoice(invoice.invoiceId).then((json) => {
			this.handleDismissDeleteClick();
			if (json && json.response && json.response.result === 'OK') {
				return new Promise((resolve, reject) => resolve(this.props.history.push('/invoices')))
			}
		})
	}

	renderDeleteModal() {
		const {isDeleteModalOpen, deleteInvoice} = this.state;

		if (!isDeleteModalOpen) {
			return null
		}

		return (
			<Modal onHide={this.handleDismissClick} show={true}>
				<Modal.Header>
					<Modal.Title>Trvalé smazání faktury</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<p>Skutečně trvale odstranit fakturu <strong>{deleteInvoice.invoiceId}</strong>? Takto akce je nevratná.</p>
				</Modal.Body>

				<Modal.Footer>
					<Row>
						<Col sm={12}>
							<Button variant={"link"} onClick={this.handleDismissDeleteClick}>Storno</Button>
							<Button type="submit" onClick={() => this.handleDeleteInvoice(deleteInvoice)} variant="danger">
								<span className="fa fa-trash"/> Trvale smazat fakturu</Button>
						</Col>
					</Row>
				</Modal.Footer>

			</Modal>
		)
	}

	render() {
		const {match: {params}, entity, session, enums} = this.props;

		if (entity.isFetchingItem || entity.item === null) {
			return Grid.renderIsFetchingData()
		}

		if ((!entity.invoiceId && !Acl.isAllowed(session, Acl.right.INVOICE_NEW))
			|| (entity.invoiceId && !Acl.hasAction(entity.item, Acl.invoice.EDIT))) {
			return Grid.renderIsDenied()
		}

		const initialValues = entity.item;
		const bc = [
			{url: '/invoices', title: 'Faktury'}
		];
		if (params.invoiceId) {
			bc.push({url: '/invoices/' + params.invoiceId, title: initialValues.invoiceId ? initialValues.invoiceId : '...'});
		} else {
			bc.push({url: '/invoices/new', title: 'Nová'});
		}

		return (
			<div>
				<Row>
					<Col xs={12}>
						{breadcrumbs(bc)}
					</Col>
				</Row>
				<InvoiceForm {...entity} initialValues={initialValues}
					onSaveInvoice={this.handleSaveInvoice}
					onDeleteInvoice={this.handleOpenDeleteClick}
					onFetchEnums={this.handleFetchEnums} enums={enums} session={session}/>
				{this.renderDeleteModal()}
			</div>
		)
	}
}

InvoiceEditPage.propTypes = {
	entity: PropTypes.object.isRequired,
	loadInvoice: PropTypes.func.isRequired,
	saveInvoice: PropTypes.func.isRequired,
	deleteInvoice: PropTypes.func.isRequired,
	loadGeneralEnum: PropTypes.func.isRequired,
	enums: PropTypes.object,
	session: PropTypes.object.isRequired,
};


const mapStateToProps = (state, ownProps) => {
	const {
		entities: {invoices},
		enums,
		session
	} = state;

	const entity = ownProps.match.params.invoiceId
		? (invoices[ownProps.match.params.invoiceId] || defaultState)
		: (invoices['new'] || Object.assign(defaultState, {item: {}}))

	return {
		entity,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadInvoice,
	saveInvoice,
	deleteInvoice,
	loadGeneralEnum,
	showMessage,
	resetEntity
})(InvoiceEditPage)
